module.exports = __webpack_public_path__ + "img/ic_mpe_chair_sm2_press.8ee815b6.png";